<template>
  <div class="flex font-sans-serif">
    <fieldset @click="openTier" class="my-2">
      <div class="w-full">
        <label class="relative bg-white border w-24 text-xs md:text-base h-auto
        md:h-20 md:w-72 p-3 shadow-lg items-center rounded-md hover:bg-grey-academy-100
        cursor-pointer hover:border-gray-500 flex justify-center uppercase tracking-widest
        focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-beige-academy-300">
          <input type="radio" name="server_size" value="Hobby" class="sr-only"
            aria-labelledby="server-size-0-label" aria-describedby="server-size-0-description-0
            server-size-0-description-1">
          <div class="flex items-center">
            <p id="server-size-0-label" class="font-medium text-gray-900">
              {{ tier.name }}
            </p>
          </div>
          <div class="border-transparent absolute -inset-px rounded-lg border-2
            pointer-events-none" aria-hidden="true"></div>
        </label>
      </div>
    </fieldset>
    <div v-if="tierDetails"
    class="flex flex-col justify-center items-center shadow-lg ml-5 md:ml-10
      rounded-md w-full my-2 font-bold bg-beige-academy-100 px-2 md:px-4 text-xs md:text-base">
      <div class="flex justify-around w-full items-center p-1">
          <span class="text-sm lg:text-lg">
            {{ tier.price ? formatter.format(tier.price/100)+'/h' : 'Free' }}</span>
          <span v-if="tier.package" class="uppercase">
            {{$t('bookingSlots.pack')}} {{tier.no_lessons}}
            {{$t('bookingSlots.lessons')}} </span>
          <span class="uppercase" v-else> {{$t('bookingSlots.single-lesson')}} </span>
      </div>
      <div class="flex items-center border-t border-grey-academy-150 w-full
      justify-center p-1 font-light text-xs md:text-base" v-if="tier.description">
        <span>{{ tier.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tier', 'editable', 'open'],

  data() {
    return {
      tierDetails: false,
    };
  },

  watch: {
    open() {
      if (this.open !== this.tier.id) {
        this.tierDetails = false;
      }
    },
  },

  methods: {
    openTier() {
      this.tierDetails = true;
      this.$emit('clicked');
    },
  },

};
</script>
